import gsap from "gsap/all";
import SplitText from "gsap/SplitText";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);


export function isThereСlass(element) {
    return (document.querySelectorAll(element).length > 0)
}

export function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

export function initMagnetBtn() {
    const magnets = document.querySelectorAll('.btn-magnet-circle');
    const strength = 70;


    if (isTouchDevice()) {
        return false;
    }
    magnets.forEach((magnet) => {
        magnet.addEventListener('mousemove', moveMagnet);
        magnet.addEventListener('mouseenter', function (event) {
            gsap.fromTo(event.currentTarget.querySelector('svg'), {
                strokeDasharray: 44,
                strokeDashoffset: 88,
                rotate: 0
            }, {
                strokeDasharray: 44,
                strokeDashoffset: 0,
                rotate: 160,
                transition: 0,
                duration: 1
            })
        });

        magnet.addEventListener('mouseleave', function (event) {
            gsap.to(event.currentTarget, {
                x: 0,
                y: 0,
                scale: 1,
            })

            gsap.fromTo(event.currentTarget.querySelector('svg'), {
                strokeDasharray: 44,
                strokeDashoffset: 44,
                rotate: 160,
            }, {
                strokeDasharray: 44,
                strokeDashoffset: 88,
                rotate: 0,
                duration: 0.6,
                transition: 0,
            })
        });
    });

    function moveMagnet(event) {
        const magnetButton = event.currentTarget
        const bounding = magnetButton.getBoundingClientRect()

        gsap.to(magnetButton, {
            x: (((event.clientX - bounding.left) / magnetButton.offsetWidth) - 0.5) * strength,
            y: (((event.clientY - bounding.top) / magnetButton.offsetHeight) - 0.5) * strength,
            scale: 1.4,
            ease: 'none',
        })
    }

}

export function initSplitText(element) {
    const textWrappers = document.querySelectorAll(element);
    const splitElement = new SplitText(element, {type: "lines", linesClass: 'lineWrapp'});

    textWrappers.forEach(textWrapper => {
        textWrapper.querySelectorAll('.lineWrapp').forEach((line) => {
            let words = line.innerHTML;
            line.innerText = '';
            line.innerHTML = `<div class="line">${words}</div>`;
        });
    });

}

export function playSplitText(element, onScroll) {
    const textWrapper = (typeof element == 'object') ? element : document.querySelector(element);
    const lines = textWrapper.querySelectorAll('.line');
    let animation;

    if (onScroll) {
        animation = gsap.timeline()
            .to(lines, {
                y: 0,
                rotateX: 0,
                stagger: 0.1,
                duration: 2,
                ease: 'power3.inOut',
            });

        ScrollTrigger.create({
            trigger: element,
            start: 'top bottom-=20%',
            end: 'top bottom-=20%',
            once: true,
            // markers: true,
            animation: animation
        })
    } else {
        animation = gsap.timeline()
            .to(lines, {
                y: 0,
                rotateX: 0,
                stagger: 0.1,
                duration: 2,
                ease: 'power3.inOut'
            });
    }
    return animation;
}

export function hideSplitText(element) {
    const textWrapper = (typeof element == 'object') ? element : document.querySelector(element);
    const lines = textWrapper.querySelectorAll('.line');

    return gsap.timeline()
        .to(lines, {
            y: '100%',
            rotateX: 60,
            stagger: 0.1,
            duration: 0.5,
            ease: 'power3.inOut'
        })
}


export function initFades(elements) {
    const fades = document.querySelectorAll(elements);

    if (!fades.length) {
        return false;
    }

    fades.forEach((fade) => {
        let content = fade.innerHTML;
        fade.innerText = '';
        fade.innerHTML = `<div class="fade-content">${content}</div>`;
    });
}

export function playFade(elements) {
    document.querySelectorAll(elements).forEach(element => {
        const child = element.querySelector('.fade-content')
        gsap.to(child, {
            scrollTrigger: {
                trigger: element,
                start: 'top bottom-=20%',
                end: 'top bottom-=20%',
                once: true,
                // markers: true
            },
            opacity: 1,
            rotateX: 0,
            y: 0,
            stagger: 0.1,
            ease: 'power3.inOut',
            duration: 2,
        })
    })
}

export function showMagnetBtn(element) {

    const btn = document.querySelector(element);
    gsap.to(btn, {
        scrollTrigger: {
            trigger: btn,
            start: 'top bottom-=20%',
            end: 'top bottom-=20%',
            onEnter: function () {
                btn.classList.add('show');
            }
        }
    })
}


export function calcContainerMargin() {
    const margin = window.getComputedStyle(document.querySelector('.container'), null).getPropertyValue("margin-left")
    document.documentElement.style.setProperty('--containerPadding', margin);
}

$(".top-slider-wrap .btn-magnet").click(function (e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $(".top-slider-wrap").height()
    }, 1000);
});



// WEBPACK FOOTER //
// ./src/js/common/help_functions.js